import { Drawer } from '@mui/material';
import { LeftMenuContent } from './content';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

type DesktopMenuProps = {
  collapsedWidth: number;
  expandedWidth: number;
};

export const DesktopMenu = ({
  collapsedWidth,
  expandedWidth,
}: DesktopMenuProps) => {
  const location = useLocation();
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    setIsExpanded(false);
  }, [location]);

  return (
    <Drawer
      onMouseEnter={() => setIsExpanded(true)}
      onMouseLeave={() => setIsExpanded(false)}
      variant="permanent"
      sx={{
        display: { xs: 'none', sm: 'block' },
        '& .MuiDrawer-paper': {
          boxSizing: 'border-box',
          width: isExpanded ? expandedWidth : collapsedWidth,
        },
      }}
    >
      <LeftMenuContent isExpanded={isExpanded} />
    </Drawer>
  );
};
